<!--
 * @description: 产品类别信息
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :autoSearch="true"
      :rowTemplate="rowTemplate"
      api="BrandType"
      editType="pop"
      :condition="conditionData"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
    >
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="add">新增</add-button>
      </template>
      <template v-slot:tabelTitleLeft>
        <div>产品类别信息</div>
      </template>
      <template v-slot:condition>
        <text-field
          v-model:value="conditionData.Bid"
          labelText="品牌名称"
          type="select"
          :clearable="true"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.Name"
          :clearable="true"
          labelText="产品类别名称"
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:checkBox01="$opData">
        <el-checkbox v-model="$opData.data.row.State"></el-checkbox>
      </template>
      <template v-slot:oprator="$opData">
        <div class="opration">
          <div class="style-aaa" @click="deleteUser($opData.data)">删除</div>
          <!-- <del-border
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="deleteUser($opData.data)"
          ></del-border> -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import delBorder from "@/components/delBorder.vue";
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { BrandType, BrandTypeDel } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { ElMessageBox } from 'element-plus'
export default {
  name: "ProductType",
  components: {
    delBorder,
    tabelPanel,
    textField,
    delButton,
    addButton,
    popDialog,
  },
  data() {
    const selectValueFn = (v, item) => {
      if (item) {
        return item.BrandName;
      }
    };
    const selectRemoteSearchData = async () => {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };
    return {
      queryShow: false,
      rowTemplate: [
        {
          headerLabel: "品牌名称",
          dataIndex: "BrandName",
          editable: true,
          sortable: true,
          selectRemoteSearchData,
          selectValueFn,
          editType: "select",
          rules: [
            {
              required: true,
              message: "请选择品牌",
            },
          ],
        },
        {
          headerLabel: "产品类别名称",
          editable: true,
          sortable: true,
          dataIndex: "Name",
          editType: "text",
          rules: [
            {
              required: true,
              message: "请输入类别名称",
            },
          ],
        },
        {
          headerLabel: "维修时间",
          editable: true,
          sortable: true,
          editType: "number",
          dataIndex: "RepairTime",
        },
        {
          headerLabel: "巡检时间",
          editable: true,
          sortable: true,
          editType: "number",
          dataIndex: "ServiceTime",
        },
        {
          headerLabel: "备注",
          editable: true,
          editType: "textarea",
          dataIndex: "Appendix",
          rows: 2,
        },
        {
          headerLabel: "操作",
          width: 140,
          slot: "oprator",
        },
      ],
      conditionData: {
        Bid: "",
        Name: "",
      },
    };
  },
  methods: {
    /**
     * @description: 获取下拉框数据
     * @param {*}
     * @return {*}
     */    
    async selectOuguName() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 获取表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 增加
    add() {
      this.$refs.tabel.showDialog(null, "新增");
    },
    // del-user
    deleteUser({ row }) {
      let id = row.id;
      	ElMessageBox.confirm("确定删除吗？", '提示', {
							confirmButtonText:"确定",
							cancelButtonText: "取消",
							type: 'warning'
						}).then(() => {
							  BrandTypeDel({ id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
						}).catch(() => {})
    
    },
    // 新加，修改-user
    popConfirmButtonClick({ slotData }) {
      if (slotData.id === null) {
        slotData.id = 0;
      }
      if (slotData.id != 0) {
        console.log(slotData, "aaaaa");
        const obj={
          ...slotData,
          // Bid:slotData.BrandName
        }
        // debugger
        BrandType(obj).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      } else {
        slotData.ServiceTime = slotData.ServiceTime || 0;
        slotData.RepairTime = slotData.RepairTime || 0;
        slotData.Appendix = slotData.Appendix || "";
        slotData.Bid = slotData.BrandName;
        let { ServiceTime, RepairTime, Name, Appendix, Bid } = slotData;

        BrandType({
          ServiceTime,
          RepairTime,
          Bid,
          Name,
          Appendix,
        }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";
.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .search-button-icon {
    background: none;
  }

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  ::v-deep
    .text-field-container
    .text-field-container-input-container
    .checkbox-group
    .checkbox-group-item {
    margin-left: 10px;
  }
}
.style-aaa{
	cursor:pointer;
	color:rgb(100,134,232);
	// style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
